import { getBaseRole } from '@/helpers/customRoles';
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import rolesEnum from '@/constant/rolesEnum'

const useRoles = () => {
  // @ts-ignore
  const role = useSelector((state) => state.profile.profile?.role)

  return useMemo(() => {
    const isAdmin = getBaseRole(role) === rolesEnum.admin
    const isJuniorAdmin = getBaseRole(role) === rolesEnum.juniorAdmin
    const isFranchiseManager = getBaseRole(role) === rolesEnum.franchiseManager
    const isAdminPanel = getBaseRole(role) === rolesEnum.adminPanel
    const isChildren = getBaseRole(role) === rolesEnum.children
    const isParent = getBaseRole(role) === rolesEnum.parent
    const isHrManager = getBaseRole(role) === rolesEnum.hrManager
    const isHtPanel = getBaseRole(role) === rolesEnum.htPanel
    const isPersonalManager = getBaseRole(role) === rolesEnum.personalManager
    const isSeminarian = getBaseRole(role) === rolesEnum.seminarian
    const isSeniorSeminarian = getBaseRole(role) === rolesEnum.seniorSeminarian
    const isAdminOrJuniorAdmin = isAdmin || isJuniorAdmin
    const isChildrenOrParent = isChildren || isParent
    const isAdminOrJuniorSeminarian = isSeminarian || isSeniorSeminarian
    const isEmployee = !isParent && !isChildren

    return {
      isAdmin,
      isJuniorAdmin,
      isFranchiseManager,
      isAdminPanel,
      isChildren,
      isParent,
      isHrManager,
      isHtPanel,
      isPersonalManager,
      isSeminarian,
      isSeniorSeminarian,
      isAdminOrJuniorAdmin,
      isChildrenOrParent,
      isAdminOrJuniorSeminarian,
      isEmployee
    }
  }, [role])
}

export default useRoles
